import { render } from "./CurrentMessageComponent.vue?vue&type=template&id=05d65c40&scoped=true"
import script from "./CurrentMessageComponent.vue?vue&type=script&lang=js"
export * from "./CurrentMessageComponent.vue?vue&type=script&lang=js"

import "./CurrentMessageComponent.vue?vue&type=style&index=0&id=05d65c40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d65c40"]])

export default __exports__